import React from "react";
import TextScreenComponent from "../../../../../../JsonScreen/Screen/ScreenComponents/TextScreenComponent/TextScreenComponent";

const TextComponent = ({component}) => {
    const {properties: {label, type}} = component;

    return (
        <div
            style={{
                overflow: 'auto',
                width: '100%',
                height: '100%'
            }}
        >
            <TextScreenComponent properties={{label, type}} styles={[{}]} fromDesigner={true}/>
        </div>
    )
};

export default TextComponent;